import { request } from '@umijs/max';

export async function uploadFile(body: any, options?: { [key: string]: any }) {
  return request<any>('/api/v1/uploadFile', {
    method: 'POST',
    data: body,
    ...(options || { headers: { 'Content-Type': 'multipart/form-data' } }),
  });
}
